module.exports = __webpack_public_path__ + "stylesheets/text-block_d5532ed820a947a03bb7b029dc95162b.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/text-block.less
// module id = eCEw
// module chunks = 153